import React from "react";
import "./assets/css/style.css";
import "./assets/css/main.css";
import "./App.css";

import Router from "./config/Router";

function App() {
  return <Router />;
}

export default App;
